export const formMutation = {
    UPDATE_FORM: 'UPDATE_FORM'
}